import { useState, useEffect } from 'react';

import { isServer } from 'lib/ssr_utils';

import { useClientHasRendered } from './use_client_has_rendered';
import { useRailsContext } from './use_rails_context';

function getMetaContent(name: string) {
  if (isServer) return '';

  return (
    document.querySelector(`meta[name="${name}"]`)?.getAttribute('content') ??
    ''
  );
}

export function useCSRF() {
  const railsContext = useRailsContext();
  const clientHasRendered = useClientHasRendered();
  const [csrfParam, setCsrfParam] = useState(
    () => railsContext?.request?.csrfParam ?? '',
  );
  const [csrfToken, setCsrfToken] = useState(
    () => railsContext?.request?.csrfToken ?? '',
  );

  useEffect(() => {
    if (!clientHasRendered) return;

    if (!csrfParam) setCsrfParam(getMetaContent('csrf-param'));
    if (!csrfToken) setCsrfToken(getMetaContent('csrf-token'));
  }, [clientHasRendered, csrfParam, csrfToken]);

  return { csrfToken, csrfParam };
}
